import { createAsyncThunk } from "@reduxjs/toolkit";
// import { axiosInstance } from '../../utils/axios-instance';

export const fetchSignIn = createAsyncThunk(
    "signInSlice/fetchSignIn",
    async () => {
        try {
            let ret = localStorage.getItem("accessToken");
            if (ret) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.error(error);
            return Promise.reject(error);
        }
    },
);
